import React from "react";
import routeGuard from "src/Hooks/routeGuard";
import DashboardDetail from "src/components/DashboardDetail";
import { RESOURCE_TYPE } from "src/constant/common";

const Dashboard = () => {
  return (
    <DashboardDetail />
  );
};

export default routeGuard(Dashboard, RESOURCE_TYPE.PROJECT_INSTANCE);